import React from "react";
import '../../Styles/notFound.css';

const NotFound = () => (
  <div className="container">
    <div className="o-cont-profile row" >
      <div className="col-sm-12" style={{ display: "flex", flexDirection: "column", width: "100rem", margin: "auto", marginTop: "3rem" }}>
        <img src="https://curriculum-vitae-lvg.vercel.app/img/notFound.webp" className="img-fluid o-photo" style={{width: "20rem", margin: "0 auto"}} alt="Not found illustration" />
        <h1>Lost in Space</h1>
            <p style={{margin: "1rem 0"}} > Uh oh!<br></br> It looks like you've drifted into a black hole. <br></br>No page here!</p>
            <a href="/" className="btn-notfound">🪐 Take me home, Captain!</a>
      </div>
      
    </div>
  </div>
);
export default NotFound;
